import { StripeError } from '@stripe/stripe-js/dist/stripe-js/stripe.js'
import { is } from 'typia'


export type StripeStartPaymentError = {
  message: string
}

type CardError = { type: 'card_error', message: string }
type ValidationError = { type: 'validation_error', message: string }

export const parseStartPaymentError = (stripeError: StripeError): StripeStartPaymentError => {
  if (is<CardError>(stripeError) || is<ValidationError>(stripeError)) {
    return { message: stripeError.message }
  }
  return { message: 'An unexpected error occurred.' }
}
